import { createContext, useContext } from "react";

import { OrderDetailsState } from "features/OrderDetails/types";

export const OrderDetailsContext = createContext<OrderDetailsState | null>(null);

export const useOrderDetailsContext = (): OrderDetailsState => {
    const state = useContext(OrderDetailsContext);

    if (!state) {
        throw new Error("useOrderDetailsContext должен использоваться внутри OrderDetails");
    }

    return state;
};
